'use client';
import { memo as Memo, useMemo } from 'react';

//* HOC's
import { withDataContext, withUIContext } from '@/context';

//* Style
import BlogStyle from './BlogStyle';

//* Component's
import Page from '@/components/common/Page';
import Text from '@/components/common/Text';
import Image from '@/components/common/Image';
import Preview from "@/modules/blog/components/Preview";
import { useRouter } from "next/navigation";
import { useApiPagination } from '@/hooks/useApiPagination';
import Pagination from "@/components/common/Pagination";

const BlogTemplate = Memo(({pageData, postsData, pagination, lang}) => {
	const router = useRouter();
	const { goTo } = useApiPagination();

	const title = useMemo(() => pageData.data[0]?.blog.title, [pageData]);

	const posts = useMemo(() => postsData.data, [postsData]);

	return (
		<Page className={'blog'}>
			<BlogStyle>
				<div className="section">
					<div className="blog-hello">
						<div className="blog-hello-content">
							<Text tag="h1" className={'h2 font-montserrat-medium'}>{title}</Text>
						</div>
						<Image className="blog-hello-image" src="/images/hello.svg"/>
					</div>
					<div className="blog-previews blog-hello-content">
						{posts.sort((a, b) => {
							const toNumber = (d) => {
								const [day, month, year] = d.split('/').map(Number);
								return year * 10000 + month * 100 + day;
							};
							return toNumber(b.publishing_date) - toNumber(a.publishing_date);
						}).map((post) => (
							<div className="blog-link" key={`/${lang}/blog/${post.slug}`}
									 onClick={() => router.push(`/${lang}/blog/${post.slug}`)}>
								<Preview post={post}/>
							</div>
						))}
					</div>
					<Pagination pagination={pagination}	/>
				</div>
			</BlogStyle>
		</Page>
	);
});

export default withUIContext(withDataContext(BlogTemplate, ['setPartners']), ['updatePageResize', 'updatePageResizeState']);
